import presignS3 from './s3Presign';

const showObject = async (filename, extension) => {
  let url = null;

  await presignS3({
    fileName: `${filename}.${extension}`,
    getObject: true,
  }).then((res) => {
    // get tokenized url to see image in private mode
    const { data } = res;
    url = data;
  }).catch(err => console.log(err));
  // console.log(url);
  return url;
};

export default showObject;
